'use strict';

var _objectSpread = require("C:\\Users\\egrie\\Repos\\creative-wall\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");

var _regeneratorRuntime = require("C:\\Users\\egrie\\Repos\\creative-wall\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\egrie\\Repos\\creative-wall\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var isIp = require('is-ip');

var defaults = {
  timeout: 5000
};
var urls = {
  v4: ['https://ipv4.icanhazip.com/', 'https://api.ipify.org/'],
  v6: ['https://ipv6.icanhazip.com/', 'https://api6.ipify.org/']
};
var xhr;

var sendXhr =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url, options, version) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              xhr = new XMLHttpRequest();
              xhr.addEventListener('error', reject, {
                once: true
              });
              xhr.addEventListener('timeout', reject, {
                once: true
              });
              xhr.addEventListener('load', function () {
                var ip = xhr.responseText.trim();

                if (!ip || !isIp[version](ip)) {
                  reject();
                  return;
                }

                resolve(ip);
              }, {
                once: true
              });
              xhr.open('GET', url);
              xhr.timeout = options.timeout;
              xhr.send();
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendXhr(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var queryHttps =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(version, options) {
    var ip, urls_, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, url;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            urls_ = [].concat.apply(urls[version], options.fallbackUrls || []);
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context2.prev = 4;
            _iterator = urls_[Symbol.iterator]();

          case 6:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context2.next = 20;
              break;
            }

            url = _step.value;
            _context2.prev = 8;
            _context2.next = 11;
            return sendXhr(url, options, version);

          case 11:
            ip = _context2.sent;
            return _context2.abrupt("return", ip);

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](8);

          case 17:
            _iteratorNormalCompletion = true;
            _context2.next = 6;
            break;

          case 20:
            _context2.next = 26;
            break;

          case 22:
            _context2.prev = 22;
            _context2.t1 = _context2["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context2.t1;

          case 26:
            _context2.prev = 26;
            _context2.prev = 27;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 29:
            _context2.prev = 29;

            if (!_didIteratorError) {
              _context2.next = 32;
              break;
            }

            throw _iteratorError;

          case 32:
            return _context2.finish(29);

          case 33:
            return _context2.finish(26);

          case 34:
            throw new Error('Couldn\'t find your IP');

          case 35:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 22, 26, 34], [8, 15], [27,, 29, 33]]);
  }));

  return function queryHttps(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

queryHttps.cancel = function () {
  xhr.abort();
};

module.exports.v4 = function (options) {
  return queryHttps('v4', _objectSpread({}, defaults, options));
};

module.exports.v6 = function (options) {
  return queryHttps('v6', _objectSpread({}, defaults, options));
};